import { useState } from "react";
import { blogPosts } from "../data/blog-posts";
import { BlogCard } from "../components/BlogCard";

export function BlogPage() {
  const allTags = Array.from(new Set(blogPosts.flatMap((p) => p.tags)));
  const [activeTag, setActiveTag] = useState<string | null>(null);

  const filtered = activeTag
    ? blogPosts.filter((p) => p.tags.includes(activeTag))
    : blogPosts;

  return (
    <main className="pt-28 pb-20">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-2xl text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary-500/20 dark:border-primary-500/30 bg-primary-500/5 dark:bg-primary-500/10 px-4 py-1.5 text-xs font-semibold tracking-wide text-primary-500 dark:text-primary-400 uppercase">
            Blog
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-4xl lg:text-5xl">
            Insights & <span className="gradient-text">Resources</span>
          </h1>
          <p className="mt-5 text-lg text-slate-600 dark:text-slate-400">
            Perspectives on task management, team performance, and the way
            modern teams ship work.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-2">
          <button
            onClick={() => setActiveTag(null)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition-all ${
              activeTag === null
                ? "bg-primary-500 text-white shadow-sm shadow-primary-500/25"
                : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700"
            }`}
          >
            All
          </button>
          {allTags.map((tag) => (
            <button
              key={tag}
              onClick={() => setActiveTag(tag)}
              className={`rounded-full px-4 py-1.5 text-sm font-medium transition-all ${
                activeTag === tag
                  ? "bg-primary-500 text-white shadow-sm shadow-primary-500/25"
                  : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((post) => (
            <BlogCard key={post.slug} post={post} />
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="mt-16 text-center text-slate-500 dark:text-slate-400">
            No posts found for this tag.
          </p>
        )}
      </div>
    </main>
  );
}
